import ComponentTempo from "../TokenCountdown/Index";
import ImgPerfil from "../../assets/logo/logo-04.png";

const Header = () => {
  const razaosocial =
    localStorage.getItem("@medusapayments:name") || "User Name";

  return (
    <header className="flex items-center justify-between px-4 py-3   text-white   ">
      {/* Nome ou Logo */}
      <div className="flex items-center   text-xs text-gray-700   rounded-lg   dark:text-gray-400  ">
        {/* Ícone de segurança (escudo com check) */}
        <svg
          className="shrink-0 inline w-4 h-4 me-2"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M10 0c-.3 0-.6.1-.8.3L3.2 3.6c-.6.3-1 .9-1 1.6V10c0 4.8 3 8.7 7.5 9.9.3.1.6.1.9 0 4.5-1.2 7.5-5.1 7.5-9.9V5.2c0-.7-.4-1.3-1-1.6L10.8.3C10.6.1 10.3 0 10 0Zm0 2 6 3v5c0 4-2.5 7.2-6 8.3-3.5-1.1-6-4.3-6-8.3V5l6-3Zm3.2 4.7-3.9 4.7-2.3-2.3a1 1 0 0 0-1.4 1.4l3 3a1 1 0 0 0 1.5-.1l4.5-5.5a1 1 0 1 0-1.5-1.3Z" />
        </svg>

        <span className="sr-only">Segurança</span>
        <div>
          <span className="font-medium">Ambiente Seguro!</span> Suas informações
          estão protegidas e este ambiente é controlado.
        </div>

        <div className="border-r-2 border-slate-300 mx-3 h-6"></div>

        <ComponentTempo />
      </div>

      <div className="flex items-center"></div>

      {/* Ícone do Usuário */}
      <div className="relative">
        <div className="flex items-center gap-3">
          <span className="text-lg   text-slate-700 font-extralight">
            {razaosocial}
          </span>

          <button className="w-10 h-10 rounded-full overflow-hidden border border-gray-500">
            <img
              src={ImgPerfil}
              alt="User"
              className="w-full h-full object-cover"
            />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
